import { render } from "./CommentRestriction.vue?vue&type=template&id=55cc30ac"
import script from "./CommentRestriction.vue?vue&type=script&lang=js"
export * from "./CommentRestriction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__